module.exports = __webpack_public_path__ + "assets/img/error.64746452.png";